import React, { useRef, useEffect, useState } from "react";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import LoadingSpinner from "../LoadingSpinner";

export default function GraficoFaixaEtaria({ dados, loadingGraficoFaixa }) {
  const chartRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setReady(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.resize();
    }
  }, [dados]);

  const labels = [
    "0 a 6 anos",
    "7 a 11 anos",
    "12 a 15 anos",
    "16 a 18 anos",
    "     Acima de 18 anos",
  ];
  const valores = [
    dados.faixa0a6 ?? null,
    dados.faixa7a11 ?? null,
    dados.faixa12a15 ?? null,
    dados.faixa16a18 ?? null,
    dados.acimaDe18 ?? null,
  ];

  const cores = ["#CBCCCE", "#9BBFA1", "#8CC7DD", "#A9B4C5", "#5689A6"];

  const data = {
    labels,
    datasets: [
      {
        label: "Total",
        data: valores,
        backgroundColor: cores,
        hoverBackgroundColor: cores,
        borderRadius: 0,
        barThickness: 40,
        minBarLength: 5,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: "center",
        align: "end",
        color: "#000",
        font: { weight: "bold", size: 12 },
        formatter: (value, context) => {
          if (value === null || value === undefined) return "";
          const total = context.chart.data.datasets[0].data
            .filter((v) => v !== null)
            .reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(2);
          return `${value} (${percentage}%)`;
        },
      },
    },
    scales: {
      x: { display: false },
      y: {
        padding: 5,
        ticks: { font: { size: 14, weight: "medium" }, color: "#2D3748" },
        grid: { display: false },
      },
    },
    layout: { padding: { right: 100 } },
  };

  return (
    <Box
      p={6}
      shadow="lg"
      backgroundColor="#F7F8FB"
      rounded="lg"
      border="1px solid #E0E6ED"
      h="400px"
    >
      {loadingGraficoFaixa ? (
        <Flex h="100%" alignItems="center" justifyContent="center">
          <LoadingSpinner />
        </Flex>
      ) : (
        ready && (
          <>
            <Heading fontSize="lg" color="#2D2F44" mb={5}>
              Acolhidos por Faixa Etária
            </Heading>

            <Box h="90%">
              <Bar
                ref={chartRef}
                data={data}
                options={options}
                plugins={[ChartDataLabels]}
              />
            </Box>
          </>
        )
      )}
    </Box>
  );
}
